module.exports = __webpack_public_path__ + "static/project-2c-654b4c39d7f378cae8a8fe5d9a3af637.png";